import Int64LookupResourceModel from '../../generated/types/model/resource/Int64LookupResourceModel';

export default class Int64LookupResourceViewModel extends Int64LookupResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
